import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsClearFieldError, fdsShowError, fdsShowFieldError } from '../modals';

// For drag/drop file support, see rov.js SVN rev. 1030

function onChooseMarkingPlan($fileComment, $fileSelector, $modal, siteIndex) {
    const $field = $(`textarea[name="caseBean.sites[${siteIndex}].markingPlan"]`);
    const type = $('input[name=type]:checked').val();
    const $plan = $('input[name=plan]:checked');

    switch (type) {
        case 'A':
            const $files = $(`input[name="caseBean.sites[${siteIndex}].chosenMarkingPlans"]`);
            $files.val($files.val() + ";" + $plan.val());
            updateMarkingPlanValue($field, `Der er valgt en af myndighedens afmærkningsplaner (${$plan.val()})`);
            new DKFDS.Modal($modal.get(0)).hide();
            break;
        case 'B':
        case 'M':
        case 'L':
            updateMarkingPlanValue($field, `Jf. vejreglernes tegningsnummer ${$plan.val()}`);
            new DKFDS.Modal($modal.get(0)).hide();
            break;
        case 'S':
            const comment = $.trim($fileComment.val());
            if (comment === '') {
                fdsShowFieldError($fileComment, 'Udfyld venligst feltet');
                return;
            }
            sendFile(
                $fileSelector[0].files[0],
                comment,
                "[Specifik afmærkning]",
                function (data) {
                    updateMarkingPlanValue($field, `${$plan.val()} (${data.filename})`);
                    new DKFDS.Modal($modal.get(0)).hide();
                },
                function () {
                    fdsShowError($modal, 'Der opstod en fejl under upload af afmærkningsplan. Filen er ikke vedhæftet.');
                }
            );
            break;
        default:
            // No other types currently exist
            break;
    }
}

function updateMarkingPlanValue($field, value) {
    $field.val($.trim(`${$field.val()}\n${value}`)).focus();
}

// This is for background file upload
async function sendFile(file, comment, category, onSuccess, onFailure) {
    const body = new FormData();
    body.append('upload', file);
    body.append('fileComment', comment);
    body.append('fileCategory', category);

    const response = await fetch('/upload-file', { method: 'POST', body });
    if (response.ok) {
        const json = await response.json();
        onSuccess(json);
    } else {
        onFailure();
    }
}

$(() => {
    const $modal = $('#chooseMarkingPlanModal');
    const $form = $('#markingPlanForm');
    const $fileComment = $('#markingPlanFileComment');
    const $fileSelector = $('#markingPlanFileSelector');
    const $button = $('#chooseMarkingPlanChooseButton');
    const $stepGuide = $modal.find('ol.sidemenu');
    const allRadios = 'input[type=radio]';
    const activeItem = 'li.active';

    $modal.get(0).addEventListener('fds.modal.shown', () => {
        $form.data('index', $(`#${$modal.get(0).dataset.modalOpener}`).data('index'));
        $modal.find(allRadios).attr('disabled', true);
        $stepGuide.find(activeItem).find(allRadios).attr('disabled', false);
    });

    $modal.get(0).addEventListener('fds.modal.hidden', () => {
        $button.attr('disabled', true);
        $stepGuide
            .find('>li')
            .removeClass('active current')
            .removeAttr('aria-current')
            .addClass('d-none');
        $stepGuide
            .find('>li:first-child')
            .addClass('active current')
            .attr('aria-current', 'step')
            .removeClass('d-none');
        $stepGuide
            .find('.sidenav-more-information')
            .removeClass('d-none');
        $stepGuide
            .find('.sidenav-icon, .sidenav-information')
            .addClass('d-none');
        $form.trigger('reset');
        $fileComment
            .removeAttr('aria-invalid aria-describedby')
            .parent()
            .removeClass('form-error')
            .children()
            .remove('.form-error-message');
    });

    $stepGuide.find('.step-button').on('click', () => {
        const $activeItem = $stepGuide.find(activeItem);
        const $radio = $activeItem.find('input[type=radio]:checked');
        $activeItem
            .removeClass('active current')
            .removeAttr('aria-current')
            .find('.sidenav-icon, .sidenav-information, .sidenav-more-information')
            .toggleClass('d-none');
        $activeItem
            .find('.sidenav-information')
            .html($radio.next().text());
        const $next = $activeItem.siblings('#' + $radio.val());
        $next
            .addClass('active current')
            .attr('aria-current', 'step')
            .removeClass('d-none');
        $next.find(allRadios).attr('disabled', false);
        $next.find('input:not([readonly])').first().focus();
    });

    $button.on('click', () => onChooseMarkingPlan($fileComment, $fileSelector, $modal, $form.data('index')));

    $stepGuide.on('change', event => {
        console.log(event);
        const selected = $(event.target).val();
        let $next = null;
        if (event.target.type !== 'file' && !selected.startsWith('http://') && !selected.startsWith('https://')) {
            $next = $stepGuide.find(activeItem).siblings('#' + selected);
        }
        if ($next === null || $next.length === 0) {
            $button.attr('disabled', false);
        }
    });

    // For type 'S'
    $fileComment.on('change', event => {
        event.stopPropagation();
        event.preventDefault();
    });
    $fileSelector.on('rov:fileselect', function () {
        if (this.files[0].size > 15*1024*1024) {
            fdsShowFieldError($(this), 'Filens størrelse skal være under 15 MB', 'mb-3');
            this.value = null;
            $button.attr('disabled', true);
            return;
        } else {
            fdsClearFieldError($(this));
        }
        $('#markingPlanFileRadio').prop('checked', true);
    });
});
